import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from '../screens/app';
import Bors from '../screens/bors';
import FrontPage from '../containers/pages/FrontPage';
import CurrenciesPage from '../containers/pages/CurrenciesPage';
import CommoditiesPage from '../containers/pages/CommoditiesPage';
import FundsPage from '../containers/pages/FundsPage';
import IndicesPage from '../containers/pages/IndicesPage';
import InterestsPage from '../containers/pages/InterestsPage';
import StocksPage from '../containers/pages/StocksPage';
import InstrumentPage from '../containers/pages/InstrumentPage';
import NotFound from '../components/NotFound';

export default () => (
    <Route component={App}>
        <Route component={Bors}>
            <IndexRoute component={FrontPage} />
            <Route path="/aktier(/:region)(/:market)(/:list)" component={StocksPage} />
            <Route path="/fond" component={FundsPage} />
            <Route path="/index" component={IndicesPage} />
            <Route path="/instrument/:symbol" component={InstrumentPage} />
            <Route path="/ravaror" component={CommoditiesPage} />
            <Route path="/renter" component={InterestsPage} />
            <Route path="/valuta" component={CurrenciesPage} />
            <Route path="*" component={NotFound} />
        </Route>
    </Route>
);



/** WEBPACK FOOTER **
 ** /src/shared/routes/index.js
 **/